//
// state
const state = {
  /** Store counterpoint round column coordinates and measurements */
  counterpointGeometries: {},

  /** Store counterpoint round column scroll position */
  counterpointOffsets: {},

  /** Store article text scroll position  */
  articleOffsets: { top: 0, left: 0 },

  /** Store outline tree scroll position */
  outlineOffsets: { top: 0, left: 0 },
};

//
// getters
const getters = {};

//
// mutations
const mutations = {
  /** Set article scroll position on __articleOffsets__ */
  setArticleOffsets: (state, offsets) => (state.articleOffsets = offsets),

  /** Set outline tree scroll position on __outlineOffsets__ */
  setOutlineOffsets: (state, offsets) => (state.outlineOffsets = offsets),
};

//
// actions
const actions = {
  /** Update counterpoint round column geometry (global position and scroll offset) */
  updateCounterpointGeometry({ state, rootState }, { geometries, cpId, cpRefEl, cpScroller }) {
    state.counterpointGeometries[cpId] = geometries;

    if (cpRefEl) {
      const scrollTop = typeof cpScroller?.scrollTop === 'number' ? cpScroller.scrollTop : 0;
      const scrollerTopStyle =
        typeof cpScroller?.$el?.style?.top === 'string' ? cpScroller.$el.style.top : undefined;
      const parsedScrollerTop = scrollerTopStyle ? parseFloat(scrollerTopStyle) : undefined;
      const offsetTop = cpRefEl.offsetTop || 0;
      const parentOffsetTop = cpRefEl.offsetParent ? cpRefEl.offsetParent.offsetTop : 0;
      const computedTop = scrollTop - offsetTop - parentOffsetTop;
      const round = rootState?.counterpointData?.rounds?.find(r => r._id === cpId)?.round;
      const previousOffset = state.counterpointOffsets[cpId];
      console.debug('[GeometriesStore] updateCounterpointGeometry', {
        cpId,
        round,
        scrollTop,
        hasScrollTop: typeof cpScroller?.scrollTop === 'number',
        scrollerTopStyle,
        parsedScrollerTop,
        offsetTop,
        parentOffsetTop,
        computedTop,
        offsetLeft: cpRefEl.offsetLeft || 0,
        geometryKeys: Object.keys(geometries || {}),
        previousOffset,
      });
      state.counterpointOffsets[cpId] = {
        top: computedTop,
        left: cpRefEl.offsetLeft || 0,
      };
    } else {
      console.debug('[GeometriesStore] updateCounterpointGeometry skipped: missing cpRefEl', {
        cpId,
        geometryKeys: Object.keys(geometries || {}),
      });
    }
  },
};

//
// exports
export default {
  // namespaced: false,
  state,
  getters,
  actions,
  mutations,
};
